import { message } from "antd";

const MAX_MESSAGES = 5;
const ERROR_DURATION = 8;

const toMessages = (value) => {
  if (!value) return [];
  if (typeof value === "string") return [value];
  if (Array.isArray(value)) return value.flatMap(toMessages);
  if (typeof value === "object") {
    return Object.entries(value).flatMap(([field, fieldErrors]) =>
      toMessages(fieldErrors).map((text) =>
        Number.isNaN(Number(field)) ? `${field}: ${text}` : text
      )
    );
  }

  return [String(value)];
};

const htmlTitle = (html) => {
  const title = /<title[^>]*>([^<]+)<\/title>/i.exec(html);
  return title ? title[1].trim() : null;
};

export const apiErrorMessages = (error) => {
  if (!error) return [];

  const response = error.response;

  if (!response) {
    return [error.message || "Network error - the server did not respond"];
  }

  const { status, statusText, data } = response;
  const statusLabel = `HTTP ${status}${statusText ? ` ${statusText}` : ""}`;

  if (typeof data === "string") {
    const title = htmlTitle(data);
    return [title ? `${statusLabel}: ${title}` : statusLabel];
  }

  const messages = toMessages(
    data?.errors || data?.error_messages || data?.message || data?.error
  );

  return messages.length ? messages : [statusLabel];
};

export const showApiError = (error, fallback) => {
  const messages = apiErrorMessages(error);

  if (!messages.length) {
    message.error(fallback, ERROR_DURATION);
    return;
  }

  const shown = messages.slice(0, MAX_MESSAGES);
  const hidden = messages.length - shown.length;
  const text = hidden > 0 ? [...shown, `+${hidden} more`] : shown;

  message.error(`${fallback}: ${text.join("; ")}`, ERROR_DURATION);

  console.error(fallback, { messages, response: error?.response?.data });
};

export default showApiError;
